import React from 'react';
import { connect } from 'react-redux'

import { Table, Row, Col, Button, Dropdown, Pagination } from 'antd';
import { SettingOutlined, DownCircleOutlined, EditOutlined, CloseCircleOutlined, PrinterOutlined } from '@ant-design/icons';

import { _fmtRupiah, _tableLogActivity, _warn, getParamTable } from '../../../../lib/Helper';

class Desktop extends React.Component {
  componentDidMount() {
    this.props.fetchTable()
  }

  render() {
    const { table } = this.props.state
    const action = this.props.access.action
    return (
      <>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Table
              columns={[
                {
                  title: 'No',
                  dataIndex: 'rownum',
                  width: '2%',
                }, {
                  title: 'Nama GTK',
                  render: (a, row) => (row.tk_gelar_depan ? row.tk_gelar_depan : "") + (row.tk_nama ? row.tk_nama : "-") + (row.tk_gelar_belakang ? " " + row.tk_gelar_belakang : "")
                }, {
                  title: 'Periode',
                  dataIndex: 'periode',
                }, {
                  title: 'Total Gaji',
                  render: (a, row) => "Rp. " + (row.gaji_kotor ? _fmtRupiah(row.gaji_kotor) : "0")
                }, {
                  title: 'Total Potongan',
                  render: (a, row) => "Rp. " + (row.total_potongan ? _fmtRupiah(row.total_potongan) : "0")
                }, {
                  title: 'Gaji yang Diterima',
                  render: (a, row) => "Rp. " + (row.gaji_bersih ? _fmtRupiah(row.gaji_bersih) : "0")
                }, {
                  title: <SettingOutlined />,
                  align: "center",
                  key: 'operation',
                  width: '2%',
                  render: (a, row) => (!action.invoice && !action.update && !action.delete ? "-" : <Dropdown trigger={['click']} menu={{
  items: [...(action.invoice ? [{
    key: 0,
    icon: <PrinterOutlined />,
    label: "Invoice",
    onClick: () => {
      _warn("topRight", "Gagal", "Maaf, fitur ini belum tersedia");
    }
  }] : []), ...(action.update ? [{
    key: 2,
    icon: <EditOutlined />,
    label: "Update",
    onClick: this.props.modalForm.bind(this, true, row)
  }] : []), ...(action.delete ? [{
    key: 3,
    icon: <CloseCircleOutlined />,
    label: "Delete",
    onClick: this.props.modalDelete.bind(this, true, row)
  }] : [])]
}}>
                    <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                  </Dropdown>),
                }, {
                  title: 'LogActivity',
                  key: 'operation',
                  width: '10%',
                  render: (a, row) => _tableLogActivity(row),
                },
              ]}
              rowKey={record => record.id}
              dataSource={table.data}
              pagination={false}
              loading={table.loading}
              size="small"
            />
          </Col>
          <Col xs={24} className="table-pagination">
            <Pagination
              size="small"
              current={table.pagination.current}
              pageSize={table.pagination.pageSize}
              total={table.pagination.total}
              showTotal={() => `Total ${table.pagination.total} items`}
              showSizeChanger
              onChange={(current, pageSize) => {
                const pagination = { current: current, pageSize: pageSize, total: table.pagination.total }
                const params = getParamTable("change", table, null, null, pagination)
                this.props.fetch(params)
              }}
            />
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(Desktop);
